import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { BsThreeDotsVertical } from "react-icons/bs";

const ActionMenu = ({ actions = [] }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btnRef = useRef(null);
  const dropdownRef = useRef(null);

  const visible = actions.filter((a) => !a.hidden);

  const handleToggle = () => {
    if (!open && btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPos({
        top: rect.bottom + window.scrollY + 4,
        left: rect.right + window.scrollX,
      });
    }
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!open) return;
    const handleClose = (e) => {
      const insideBtn = btnRef.current?.contains(e.target);
      const insideDropdown = dropdownRef.current?.contains(e.target);
      if (!insideBtn && !insideDropdown) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClose);
    return () => document.removeEventListener("mousedown", handleClose);
  }, [open]);

  const dropdown = open ? (
    <div
      ref={dropdownRef}
      style={{
        position: "absolute",
        top: pos.top,
        left: pos.left,
        transform: "translateX(-100%)",
        background: "#fff",
        border: "1px solid #e9ecef",
        borderRadius: 10,
        boxShadow: "0 8px 24px rgba(0,0,0,0.13)",
        minWidth: 190,
        zIndex: 99999,
        overflow: "hidden",
      }}
    >
      {visible.map((action, i) => (
        <button
          key={i}
          disabled={action.disabled}
          onClick={() => {
            if (!action.disabled) {
              action.onClick();
              setOpen(false);
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 10,
            width: "100%",
            padding: "10px 16px",
            background: "transparent",
            border: "none",
            borderTop: i > 0 ? "1px solid #f1f3f5" : "none",
            cursor: action.disabled ? "not-allowed" : "pointer",
            opacity: action.disabled ? 0.4 : 1,
            color: action.danger ? "#dc3545" : "#343a40",
            fontSize: "0.82rem",
            fontWeight: 500,
            letterSpacing: "0.01em",
            textAlign: "left",
            transition: "background 0.15s",
          }}
          onMouseEnter={(e) => {
            if (!action.disabled)
              e.currentTarget.style.background = action.danger
                ? "rgba(220,53,69,0.07)"
                : "#f8f9fa";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "transparent";
          }}
        >
          {action.icon && (
            <span
              style={{
                fontSize: "1rem",
                width: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: action.danger ? "#dc3545" : "#6c757d",
                flexShrink: 0,
              }}
            >
              {action.icon}
            </span>
          )}
          {action.label}
        </button>
      ))}
    </div>
  ) : null;

  return (
    <>
      <button
        ref={btnRef}
        className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: 34,
          height: 34,
          padding: 0,
          border: "1px solid #dee2e6",
          boxShadow: "none",
        }}
        onClick={handleToggle}
      >
        <BsThreeDotsVertical size={16} color="#555" />
      </button>

      {ReactDOM.createPortal(dropdown, document.body)}
    </>
  );
};

export default ActionMenu;
